<script src="orgchart.js"></script>
<style>
  ::ng-deep [data-n-id='{{chartTitle}}'] rect {
    fill: #fcd9a7;
  }
</style>
<mat-card>
  <mat-card-title class="header">
    <h5>{{chartTitle}}</h5>
  </mat-card-title>
  
  <mat-card-content>
    <div class="buttons">
      <button mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="toggleTreeLayout()">Toggle Layout</button>
      <button mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="expandCollapse()">Expand All</button>
      <button mat-stroked-button id ="showFiltersButton" setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="showFilters()">Show Filters</button>
      <button *ngIf="isFiltered" mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="showAllNodes()">Show All</button>
    </div>
    <div id="OrgTree" class="OrgTreeContainer">
    </div>

  </mat-card-content>

</mat-card>
